/* istanbul ignore file */
export * from './SeoProductCategoryNavigation';
